import * as I18n from 'i18n-js';
import { Helmet } from 'react-helmet';

import {
  AddressBook,
  AffirmBanner,
  AppProvider,
  ArticleEmbed,
  ArticleGridEmbed,
  AutoOfferModalButton,
  BrandCalloutEmbed,
  BrowserInfoHiddenFields,
  CSPMiniGridEmbed,
  CalloutEmbed,
  CartItemActions,
  CartNudge,
  CategoryCalloutEmbed,
  CategoryNestedNav,
  CheckoutAddressBook,
  ComparisonShoppingPageCardManager,
  CreateOfferButton,
  EmailSignUpEmbed,
  FeedbackContainer,
  FollowButtonContainer,
  GiftCardSendDatePicker,
  HandpickedCalloutEmbed,
  Headerv2Categories,
  HomepageCuratedSetRow,
  ItemRelatedBuyingGuide,
  Spinner,
  LPAlbumRowEmbed,
  setRoutes,
  LightboxImage,
  ListingRow,
  ListingSidebarCSP,
  MessageForm,
  MessageInput,
  MobileDetection,
  Modal,
  NewsNav,
  OfferButtonWithFlash,
  PaywallBillingMethod,
  Photos,
  PromoCodeRedemptionForm,
  PropertySwitcher,
  RefundRequestFormFields,
  RegionalListings,
  SellCSPPreview,
  ShipOrderHeader,
  SimilarCSPsRow,
  SiteSearch,
  StarRating,
  StarRatingSelector,
  StatementBillingMethodContainer,
  Translations,
  UpdateOfferButton,
  VideoEmbed,
  alt,
  buildReverbRouter,
  buildRootRoutes,
} from '@reverbdotcom/discovery-ui';

import {
  CMSTranslations,
  CommonsTranslations,
} from '@reverbdotcom/commons';

import Routes from './shared/routes';
import trackPageView from './track_page_view';

I18n.translations.en.discovery = Translations;
I18n.translations.en.cms = CMSTranslations;
I18n.translations.en.commons = CommonsTranslations;

window.Reverb = window.Reverb || {};
window.ReverbAppProviderV2 = AppProvider;
window.Reverb.AffirmBanner = AffirmBanner;
window.Reverb.ArticleEmbed = ArticleEmbed;
window.Reverb.ArticleGridEmbed = ArticleGridEmbed;
window.Reverb.AutoOfferModalButton = AutoOfferModalButton;
window.Reverb.BrandCalloutEmbed = BrandCalloutEmbed;
window.Reverb.BrowserInfoHiddenFields = BrowserInfoHiddenFields;
window.Reverb.CalloutEmbed = CalloutEmbed;
window.Reverb.CartNudge = CartNudge;
window.Reverb.CategoryCalloutEmbed = CategoryCalloutEmbed;
window.Reverb.LPAlbumRowEmbed = LPAlbumRowEmbed;
window.Reverb.CategoryNestedNav = CategoryNestedNav;
window.Reverb.ComparisonShoppingPageCardManager = ComparisonShoppingPageCardManager;
window.Reverb.CreateOfferButton = CreateOfferButton;
window.Reverb.OfferButton = OfferButtonWithFlash;
window.Reverb.CSPMiniGridEmbed = CSPMiniGridEmbed;
window.Reverb.Spinner = Spinner;
window.Reverb.ListingSidebarCSP = ListingSidebarCSP;
window.Reverb.FeedbackContainer = FeedbackContainer;
window.Reverb.FollowButtonContainer = FollowButtonContainer;
window.Reverb.HandpickedCalloutEmbed = HandpickedCalloutEmbed;
window.Reverb.HomepageCuratedSetRow = HomepageCuratedSetRow;
window.Reverb.Headerv2Categories = Headerv2Categories;
window.Reverb.LightboxImage = LightboxImage;
window.Reverb.ListingRow = ListingRow;
window.Reverb.Modal = Modal;
window.Reverb.NewsNav = NewsNav;
window.Reverb.PaywallBillingMethod = PaywallBillingMethod;
window.Reverb.PropertySwitcher = PropertySwitcher;
window.Reverb.RegionalListings = RegionalListings;
window.Reverb.SimilarCSPsRow = SimilarCSPsRow;
window.Reverb.SearchBarV2 = SiteSearch;
window.Reverb.StarRating = StarRating;
window.Reverb.StarRatingSelector = StarRatingSelector;
window.Reverb.StatementBillingMethodContainer = StatementBillingMethodContainer;
window.Reverb.UpdateOfferButton = UpdateOfferButton;
window.Reverb.VideoEmbed = VideoEmbed;
window.Reverb.SellCSPPreview = SellCSPPreview;
window.Reverb.AddressBook = AddressBook;
window.Reverb.CheckoutAddressBook = CheckoutAddressBook;
window.Reverb.EmailSignUp = EmailSignUpEmbed;
window.Reverb.GiftCardSendDatePicker = GiftCardSendDatePicker;
window.Reverb.ShipOrderHeader = ShipOrderHeader;
window.Reverb.Photos = Photos;
window.Reverb.ItemRelatedBuyingGuide = ItemRelatedBuyingGuide;
window.Reverb.RefundRequests = {
  FormFields: RefundRequestFormFields,
};
window.Reverb.CartItemActions = CartItemActions;

window.Reverb.CommonAlt = alt;
window.RREHelmet = Helmet;

window.Reverb.Routes = buildRootRoutes(Routes); // exposed for server side rendering
setRoutes(window.Reverb.Routes);


window.Reverb.noRouterContext = true;
window.Reverb.Router = buildReverbRouter(Routes, {
  onUpdate: () => {
    trackPageView(window.location);
    window.Reverb.noRouterContext = false;
  },
});

window.Reverb.MobileDetection = MobileDetection;

window.Reverb.Conversations = window.Reverb.Conversations || {};
window.Reverb.Conversations.BodyInput = MessageInput;
window.Reverb.Conversations.Form = MessageForm;
window.Reverb.PromoCodeRedemptionForm = PromoCodeRedemptionForm;



// WEBPACK FOOTER //
// ./javascripts/components/discovery.js